import { CHECK_EMAIL_REMINDER_PARAM } from "src/components/collapsible-header/CollapsibleHeader";
import getStore from "src/utils/redux/store";
import { updateForwardedParams } from "src/utils/urlParams";
import goto from ".";
import { CollapsibleHeaderUrlParams } from "./offers";
import { forwardUpid } from "./utils";

export default {
  supporterPlan({ showEmailReminder }: CollapsibleHeaderUrlParams) {
    updateForwardedParams({
      [CHECK_EMAIL_REMINDER_PARAM]: showEmailReminder,
    });
    forwardUpid(getStore());

    goto.layer("supporter-plan");
  },
};
